import { useState, useCallback } from 'react';
import {
  externalLoginTelmexService,
  externalLoginUser,
} from 'api/services/user/externalLoginTelmex';
import useHandleUserProvider from 'context/hooks/useHandleUserProvider';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';

const useExternalTelmexLogin = (onOtpAndHandoffFinish) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [showLoaderRequest, setShowLoaderRequest] = useState(false);
  const [requestError, setRequestError] = useState(false);
  const { loginApp } = useHandleUserProvider();
  const iframeSource = useSelector(
   selectMetadataKeyByRegion('iframe_telmex_config')
  );

  const handleExternalLogin = useCallback(
    async data => {
      setShowLoaderRequest(true);
      try {
        const response = await externalLoginTelmexService(data, iframeSource?.source);

        if (!response?.ok) {
          setRequestError(true);
          setIsOpen(true);
          setShowLoaderRequest(false);
          return;
        }

        await externalLoginUser(response.data?.data, loginApp, dispatch, navigate);
        setShowLoaderRequest(false);
      } catch (error) {
        setRequestError(true);
        setIsOpen(true);
        setShowLoaderRequest(false);
      }
    },
    [loginApp, dispatch],
  );

  const handleOtpAndHandoffFinish = async data => {
    setShowLoaderRequest(true);
    try {
      const response = await externalLoginTelmexService(data, iframeSource?.source);

      if (!response?.ok) {
        setRequestError(true);
        setIsOpen(true);
        setShowLoaderRequest(false);
        return;
      }

      if (onOtpAndHandoffFinish) {
        await onOtpAndHandoffFinish(response?.data);
      }
      setShowLoaderRequest(false);
    } catch (error) {
      setRequestError(true);
      setIsOpen(true);
      setShowLoaderRequest(false);
    }
  };

  return {
    isOpen,
    setIsOpen,
    requestError,
    setRequestError,
    handleExternalLogin,
    showLoaderRequest,
    handleOtpAndHandoffFinish,
  };
};

export default useExternalTelmexLogin;
